import { render, staticRenderFns } from "./AddressRentList.vue?vue&type=template&id=18d2e4ee&scoped=true&"
import script from "./AddressRentList.vue?vue&type=script&lang=js&"
export * from "./AddressRentList.vue?vue&type=script&lang=js&"
import style0 from "./AddressRentList.vue?vue&type=style&index=0&id=18d2e4ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2e4ee",
  null
  
)

export default component.exports